module.exports = __webpack_public_path__ + "static/img/view1-1.b033cd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/lobby/components1030/img/1030/view1-1.png
// module id = s+sL
// module chunks = 1